import { DataSourceView } from '../api/generated/models/DataSourceView';

/**
 * "Is a DataSource configured?" gate used by feature pages, guards and the
 * session bootstrap.
 *
 * - Bridge DataSource: connection fields are intentionally empty (the
 *   credentials never leave the customer's server), so "configured" means the
 *   Wawi Bridge agent has completed pairing.
 * - Direct DataSource: GET /ds returns masked values (e.g. "5.1**", "eaz**",
 *   username "**") and often `port: 0` when the real port is hidden - that
 *   must still count as "configured".
 */
export function isDataSourceConfigured(data: DataSourceView | null | undefined): boolean {
  if (!data) return false;

  if (data.type === DataSourceView.type.BRIDGE) {
    return data.bridge?.paired === true;
  }

  const host = typeof data.host === 'string' ? data.host.trim() : '';
  const database = typeof data.database === 'string' ? data.database.trim() : '';
  if (!host || !database) return false;

  const port = data.port;
  if (port == null) return true;
  if (port === 0) return true;
  return port >= 1 && port <= 65535;
}
